import React, {Component} from 'react';
import PropTypes from "prop-types";
import {UecareUploadAvatar} from "./";


class UecareAvatar extends Component {

    static propTypes = {
        className: PropTypes.any,
        src: PropTypes.string,
    };

    render() {
        return (<UecareUploadAvatar {...this.props} canChangeAvatar={false}/>);
    }
}

export default UecareAvatar;



// WEBPACK FOOTER //
// ./src/components/UecareAvatar.js